/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import createStyles from '@mui/styles/createStyles';
import { ClientPersonReferenceWithEmail } from '@DigitaleDoerfer/digitale-doerfer-api';

export const commonStyles = createStyles({
	gridFirstItem: {
		paddingTop: '0 !important'
	},
	typographyTitle: {
		marginTop: '20px !important',
		marginBottom: '0 !important'
	},
	listItem: {
		paddingLeft: 0
	},
	highlight: {
		backgroundColor: '#ff8b8c',
		borderRadius: '4px'
	},
	textMarkedAsDeleted: {
		textDecoration: 'line-through'
	},
	deletionTextIndicator: {
		fontStyle: 'italic'
	},
	textWrap: {
		wordWrap: 'break-word'
	}
});

export interface FlagSummary {
	text?: string;
	tenantName?: string;
	reason?: string;
	status?: string;
	lastStatusUpdate?: string;
	highlightedCommentId?: string;
	flagCreator?: ClientPersonReferenceWithEmail;
}
